module.exports = __webpack_public_path__ + "img/img_slide_7.d4ab1626.webp";